import Voting from "./components/Voting/Voting";
import htmx from "htmx.org";
import { LightGallery } from './components/LightGallery/LightGallery.js';

htmx.on('htmx:afterRequest', (event) => {
  if (event.detail.target.id === 'voting-sprig') {
    const votingSection = document.querySelector('.cmp-voting-section');
    new Voting(votingSection);

    // init Light gallery after htmx is loaded
    LightGallery()
  }
});